import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { ReceivingPlan } from 'services/action';

import * as Fi from 'react-icons/fi';
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import cn from 'classnames';

import { Skeletons } from 'ui/components/skeleton';

const initialState = {
  showDelete: false,
  showComplete: false
};

export const Action = ({ data, isLoading, onSubmit }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state.Form);

  const dummy = Array.from({ length: 4 }, (v, i) => i);

  const [{ showDelete, showComplete }, setState] = React.useState(initialState);

  const $handleClose = () => {
    setState((prevState) => ({ ...prevState, showDelete: false, showComplete: false }));
  };

  const $handlePublish = async () => {
    const req = await Dispatch(ReceivingPlan.$publish(data?.id));
    if (req?.message === 'success') {
      $handleClose();
      onSubmit();
    }
  };

  const $handleComplete = async () => {
    const req = await Dispatch(ReceivingPlan.$complete(data?.id));
    if (req?.message === 'success') {
      $handleClose();
      onSubmit();
    }
  };

  const $handleDelete = async () => {
    const del = await Dispatch(ReceivingPlan.$delete(data?.id));
    if (del?.message === 'success') {
      $handleClose();
      History.replace('/receiving/plan');
    }
  };

  const StandardAction = () => {
    return (
      <>
        {data?.document_status === 'new' && (
          <>
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id={`tooltip-top`}>Perbaharui</Tooltip>}
            >
              <Link
                to={`/receiving/plan/${data?.id}/update`}
                className={cn('btn btn-primary px-2')}
              >
                <Fi.FiEdit size="17" />
              </Link>
            </OverlayTrigger>

            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id={`tooltip-top`}>Publish</Tooltip>}
            >
              <button
                className={cn('btn btn-success px-2')}
                onClick={$handlePublish}
              >
                <Fi.FiCheckCircle size="17"/>
              </button>
            </OverlayTrigger>

            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id={`tooltip-top`}>Hapus</Tooltip>}
            >
              <button
                className={cn('btn btn-danger px-2')}
                onClick={() =>
                  setState((prevState) => ({ ...prevState, showDelete: true }))
                }
              >
                <Fi.FiTrash2 size="17" />
              </button>
            </OverlayTrigger>
          </>
        )}
      </>
    );
  };

  return (
    <div className="d-flex align-items-center gap-1 px-3 px-md-0 pb-2 pb-md-0">
      {isLoading ? (
        dummy?.map((d, i) => <Skeletons key={i} height="35px" width="35px" />)
      ) : (
        <>
          <StandardAction />
          {data?.document_status === "active" && (
            <>
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id={`tooltip-top`}>Terima Barang</Tooltip>}
              >
                <Link
                  to={{
                    pathname: '/receiving/receive/create',
                    state: { plan: data?.id },
                  }}
                  className={cn('btn btn-success px-2 py-1')}
                >
                  <Fi.FiCheckCircle size="17" />
                  Terima Barang
                </Link>
              </OverlayTrigger>

              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id={`tooltip-top`}>Complete</Tooltip>}
              >
                <button
                  className={cn('btn btn-info px-2 py-1')}
                  onClick={() =>
                    setState((prevState) => ({ ...prevState, showComplete: true }))
                  }
                >
                  <Fi.FiCheckCircle size="17" /> Complete
                </button>
              </OverlayTrigger>
            </>
          )}
        </>
      )}

      {/* modal delete */}
      <Modal
        show={showDelete}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Data yang sudah dihapus tidak bisa dipulihkan
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$handleClose}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={$handleDelete}
                disabled={StateForm?.loading}
              >
                Hapus
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* modal complete */}
      <Modal
        show={showComplete}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-info" />
          <Fi.FiAlertTriangle className="mb-2 text-info" size={90} />
            <h3>Anda yakin?</h3>
            <p className="text-info fw-semibold">
              Rencana penerimaan tidak dapat diterima lagi, apabila sudah diselesaikan
            </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button
                variant="white"
                className="w-100"
                onClick={$handleClose}
              >
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="info"
                className={
                  StateForm?.loading ? ' btn-loading w-100' : 'w-100'
                }
                onClick={$handleComplete}
                disabled={StateForm?.loading}
              >
                Ya
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
